module.exports = __webpack_public_path__ + "static/12-insights-a088911ff6984bc1e54d554283ac8972.jpg";